import Vue from 'vue';

let currentDomain = document.domain; // 私有部署自适应域名

if (currentDomain == 'localhost') {
  Vue.prototype.totalUrl = 'https://total.api.jk125.com'; // 总后台api地址
  Vue.prototype.FrontUrl = 'https://account.jk125.com'; // 前端域名
  Vue.prototype.ApiUrl = 'http://api.jk125.com/index.php'; // 后端api地址
  Vue.prototype.ImgUrl = 'http://api.jk125.com'; // 图片地址
  Vue.prototype.CloudUrl = 'http://api.xlcloud.cc/index.php';
  Vue.prototype.MqttUrl = "ws://127.0.0.1:8083/mqtt"
} else if (currentDomain == 'adm.jk125.com') {
  Vue.prototype.totalUrl = 'https://total.api.jk125.com'; // 总后台api地址
  Vue.prototype.FrontUrl = 'https://account.jk125.com'; // 前端域名
  Vue.prototype.ApiUrl = 'https://adm.api.jk125.com/index.php'; // 后端api地址
  Vue.prototype.ImgUrl = 'https://adm.api.jk125.com'; // 图片地址
  Vue.prototype.CloudUrl = 'https://api.cloud.jk125.com/index.php';
  Vue.prototype.MqttUrl = "wss://cs.cloud.jk125.com/websocket/"
} else {
  /* 后端api地址 */
  Vue.prototype.ApiUrl = 'https://' + currentDomain + '/index.php';
  /* 总后台api地址*/
  Vue.prototype.totalUrl = 'https://total.api.jk125.com';
  /* 图片地址 */
  Vue.prototype.ImgUrl = 'https://' + currentDomain;
  /* 前端域名 */
  Vue.prototype.FrontUrl = 'https://' + currentDomain;
  /* 云端域名 */
  Vue.prototype.CloudUrl = 'https://api.cloud.jk125.com/index.php';
  Vue.prototype.MqttUrl = currentDomain == 'ar.apply.jk125.com' ? "wss://ar.apply.jk125.com/websocket/" :
    "wss://cs.cloud.jk125.com/websocket/"
}



// WEBPACK FOOTER //
// ./src/assets/js/private.js